import { render, staticRenderFns } from "./FacturasMX.vue?vue&type=template&id=048e780e&scoped=true"
import script from "./FacturasMX.vue?vue&type=script&lang=js"
export * from "./FacturasMX.vue?vue&type=script&lang=js"
import style0 from "./FacturasMX.vue?vue&type=style&index=0&id=048e780e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e780e",
  null
  
)

export default component.exports